import { Reducer } from 'redux';
import { api } from '../../libs';
import { ILoginAction, LOGIN_ERROR, LOGIN_SUCCESS, LOGOUT_REQUEST } from '../actions/auth';
import { IUser } from '../types/user';

export interface IAuthState {
  accessToken: string | null;
  refreshToken: string | null;
  accessTokenExpiresAt: Date | null;
  user: IUser | null;
  error?: string;
}

export const initialState: IAuthState = {
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') as string) : null,
  accessToken: localStorage.getItem('accessToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null,
  accessTokenExpiresAt: localStorage.getItem('accessTokenExpiresAt')
    ? new Date(localStorage.getItem('accessTokenExpiresAt') as string)
    : null,
};
api.setAccessToken(initialState.accessToken || '');

const reducer: Reducer<any> = (
  state: IAuthState = initialState,
  action: ILoginAction
): IAuthState => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      if (["+420605990283", "+420774481766"].includes(action.payload.user.phone)) {
        action.payload.user.roles.push("sales");
      }
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('accessToken', action.payload.accessToken);
      localStorage.setItem('refreshToken', action.payload.refreshToken);
      localStorage.setItem(
        'accessTokenExpiresAt',
        action.payload.accessTokenExpiresAt.toISOString()
      );
      return action.payload;
    case LOGOUT_REQUEST:
    case LOGIN_ERROR:
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('accessTokenExpiresAt');
      return {
        user: null,
        accessToken: null,
        refreshToken: null,
        accessTokenExpiresAt: null,

        ...(action.type === LOGIN_ERROR
          ? {
              error: action.message,
            }
          : {}),
      };
  }
  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/auth.ts